export default () => <div>404 - Page Not Found</div>;
